import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import Loader from "src/components/Loader";
import { assignClientPackage } from "src/store/clients/saga";
import { getPackageListSaga } from "src/store/web-packages/saga";

const AssignPackageModal = ({
  clientId,
  show,
  setShow,
  onSuccess,
}: {
  clientId: string;
  show: boolean;
  setShow: (show: boolean) => void;
  onSuccess: () => void;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [packages, setPackages] = useState<any[]>([]);
  const [packageId, setPackageId] = useState("");
  const [isMonth, setIsMonth] = useState(false); // default: Yıllık
  const [amount, setAmount] = useState("0");

  useEffect(() => {
    if (!show) return;
    setPackageId("");
    setIsMonth(false);
    setAmount("0");
    dispatch(
      getPackageListSaga({
        payload: {
          onSuccess: (_m: string, list: any[]) => setPackages(list || []),
          onError: () => {},
        },
        params: "?page=1&pageSize=200",
      })
    );
  }, [show, dispatch]);

  const assign = () => {
    if (!packageId) {
      toast.error(t("Clients.Packages.SelectPackage", "Lütfen bir paket seçin"), {
        theme: "colored",
      });
      return;
    }
    setLoader(true);
    dispatch(
      assignClientPackage({
        body: {
          ClientId: clientId,
          PackageId: packageId,
          IsMonth: isMonth,
          Amount: Number(amount) || 0,
        },
        payload: {
          onSuccess: (message: string) => {
            toast.success(message, { theme: "colored" });
            setLoader(false);
            setShow(false);
            onSuccess();
          },
          onError: (message: string) => {
            toast.error(message, { theme: "colored" });
            setLoader(false);
          },
        },
      })
    );
  };

  return (
    <Modal isOpen={show} toggle={() => setShow(false)}>
      <ModalHeader toggle={() => setShow(false)}>
        {t("Clients.Packages.Assign", "Paket Ata")}
      </ModalHeader>
      <ModalBody>
        {loader && <Loader />}
        <FormGroup>
          <Label>{t("Clients.Packages.Name", "Paket")}</Label>
          <Input
            type="select"
            value={packageId}
            onChange={(e) => setPackageId(e.target.value)}
          >
            <option value="">
              {t("Clients.Packages.SelectPackage", "Paket seçin")}
            </option>
            {packages.map((p) => (
              <option key={p.Id} value={p.Id}>
                {p.Name}
              </option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup>
          <Label>{t("Clients.Packages.Period", "Dönem")}</Label>
          <Input
            type="select"
            value={isMonth ? "month" : "year"}
            onChange={(e) => setIsMonth(e.target.value === "month")}
          >
            <option value="year">{t("Yearly", "Yıllık")}</option>
            <option value="month">{t("Monthly", "Aylık")}</option>
          </Input>
        </FormGroup>
        <FormGroup>
          <Label>{t("Clients.Packages.Amount", "Tutar")}</Label>
          <Input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </FormGroup>
        <div className="d-flex justify-content-end mt-3">
          <Button color="light" className="me-2" onClick={() => setShow(false)}>
            {t("Cancel", "İptal")}
          </Button>
          <Button color="success" disabled={!packageId} onClick={assign}>
            {t("Clients.Packages.Assign", "Paket Ata")}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AssignPackageModal;
